import React, { useState } from 'react';
import { CheckIcon, ChevronDownIcon, ChevronUpIcon, CircleIcon, MenuIcon, XIcon } from 'lucide-react';
import type { CourseSection } from '../../types/survey';
interface CourseContentsPanelProps {
  sections: CourseSection[];
  activeItemId: string;
  onClose?: () => void;
}
export function CourseContentsPanel({
  sections,
  activeItemId,
  onClose
}: CourseContentsPanelProps) {
  const [expanded, setExpanded] = useState<string[]>(sections.filter(section => section.items?.length).map(s => s.id));
  const toggle = (id: string) => {
    setExpanded(current => current.includes(id) ? current.filter(value => value !== id) : [...current, id]);
  };
  return <nav aria-label="Course contents" className="bg-white" data-id="element-2079" data-mp="11tlxlwhbo9am">
      <div className="flex items-center justify-between gap-2 border border-gray-400 bg-gray-100 px-4 py-4" data-id="element-2080" data-mp="e52mzaasvkfd">
        <span className="flex items-center gap-3 text-base font-semibold text-gray-700" data-id="element-2081" data-mp="979hykl8gwgo">
          <MenuIcon size={20} aria-hidden="true" className="text-gray-800" data-id="element-2082" data-mp="3edkxfgetqrc4" />
          Contents
        </span>
        {onClose && <button type="button" onClick={onClose} aria-label="Hide course contents" className="text-gray-800 hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500" data-id="element-2083" data-mp="3jal2pp3unq26">
            <XIcon size={20} aria-hidden="true" data-id="element-2084" data-mp="2vegsojubfjq9" />
          </button>}
      </div>

      <ul className="border-x border-b border-gray-200" data-id="element-2085" data-mp="30da1hyynqmk3">
        {sections.map(section => {
        const hasItems = Boolean(section.items?.length);
        const isOpen = expanded.includes(section.id);
        return <li key={section.id} className="border-b border-gray-200 last:border-b-0" data-id="element-2086" data-mp="39f1959crd3gl">
              <button type="button" onClick={() => hasItems && toggle(section.id)} aria-expanded={hasItems ? isOpen : undefined} className={`flex w-full items-start justify-between gap-3 px-4 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gray-500 ${hasItems ? '' : 'cursor-default'}`} data-id="element-2087" data-mp="kmp2gvfdvwqp">
                <span className="text-base leading-snug text-gray-900" data-id="element-2088" data-mp="2uo0c6iuym4fa">
                  {section.title}
                </span>
                {isOpen ? <ChevronUpIcon size={18} aria-hidden="true" className="mt-1 flex-none text-gray-900" data-id="element-2089" data-mp="220e3iw6vk9lk" /> : <ChevronDownIcon size={18} aria-hidden="true" className="mt-1 flex-none text-gray-900" data-id="element-2090" data-mp="2bpxme1ul83gf" />}
              </button>

              {hasItems && isOpen && <ul data-id="element-2091" data-mp="1j7tnwgg6s0zp">
                  {section.items?.map(item => {
              const isActive = item.id === activeItemId;
              return <li key={item.id} className="border-t border-gray-200" data-id="element-2092" data-mp="3pxdg7tyoesj7">
                        <a href={`#${item.id}`} aria-current={isActive ? 'page' : undefined} className={`flex items-center gap-3 py-4 pl-6 pr-4 text-base ${isActive ? 'bg-gray-200 text-gray-700' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2093" data-mp="3gxgykcapetxn">
                          {item.status === 'complete' ? <span aria-hidden="true" className="flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-[#1E8E3E]" data-id="element-2094" data-mp="8hf4e3cfe94c">
                              <CheckIcon size={11} strokeWidth={3.5} className="text-white" data-id="element-2095" data-mp="2t9h8zfp4p9kn" />
                            </span> : <CircleIcon size={18} aria-hidden="true" className="flex-none text-gray-500" data-id="element-2096" data-mp="2zqam2twla8ni" />}
                          <span className="truncate" data-id="element-2097" data-mp="3netvjcrdkrh6">{item.title}</span>
                          <span className="sr-only" data-id="element-2098" data-mp="3nfleno3scwqk">
                            {item.status === 'complete' ? ' (completed)' : ' (not started)'}
                          </span>
                        </a>
                      </li>;
            })}
                </ul>}
            </li>;
      })}
      </ul>
    </nav>;
}